import React from "react";

import { templates } from "@reactivated";

import { PDPChangeVariantOptionBlock } from "../apps/configurator/PDPChangeVariantOptionBlock";
import { IOptionCode } from "../models/catalogue";

export const Template = (
    props: templates.ChangeVariantOptionBlockTemplate,
): React.JSX.Element => {
    return (
        <div>
            <PDPChangeVariantOptionBlock
                attributeCode={props.attribute_code as IOptionCode}
                inputType={props.input_type}
                initialOptionValuesData={props.initial_option_values_data}
                initialSelectedValue={props.initial_selected_value}
            />
        </div>
    );
};
